import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "@flaticon/flaticon-uicons/css/all/all.css";
import * as Constants from "../../config/constants";
import { toggleNav, handleActiveClass } from "../../assets/js/common";
import logo from "../../assets/images/header-logo.png";

export default function Header({ settingInfo }) {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const pathname = location.pathname;

  /* =====================================================
   * ACTIVE NAV RULES (FINAL)
   * ===================================================== */

  // Newsletter ONLY
  const isNewsletterActive =
    pathname === "/resources/newsletter/" ||
    pathname.startsWith("/resources/newsletter/");

  // Resources for ALL other /resources/* routes
  const isResourcesActive =
    pathname.startsWith("/resources/") && !isNewsletterActive;

  const handleDropdownClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setIsOpen((prev) => !prev);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Re-run legacy handler on route change (safe)
  useEffect(() => {
    handleActiveClass();
    // eslint-disable-next-line
  }, [location.pathname]);

  // Desktop hover dropdown with cleanup
  useEffect(() => {
    if (window.innerWidth <= 991) return;

    const dropdowns = document.querySelectorAll(
      ".twt-navbar .nav-item.dropdown, .twt-navbar .dropdown-submenu"
    );

    const handlers = [];

    dropdowns.forEach((dropdown) => {
      const dropdownMenu = dropdown.querySelector(".dropdown-menu");
      if (!dropdownMenu) return;

      const onMouseOver = () => dropdownMenu.classList.add("show");
      const onMouseLeave = () => dropdownMenu.classList.remove("show");

      dropdown.addEventListener("mouseover", onMouseOver);
      dropdown.addEventListener("mouseleave", onMouseLeave);

      handlers.push({ dropdown, onMouseOver, onMouseLeave });
    });

    return () => {
      handlers.forEach(({ dropdown, onMouseOver, onMouseLeave }) => {
        dropdown.removeEventListener("mouseover", onMouseOver);
        dropdown.removeEventListener("mouseleave", onMouseLeave);
      });
    };
  }, []);

  return (
    <header>
      <div className="main-navbar-wrapper">
        <nav className="navbar twt-navbar twt-navbar-common navbar-expand-lg" id="navMain">
          <div className="container">
            <Link className="navbar-brand" to="/">
              {settingInfo?.website_logo ? (
                <img
                  src={Constants.BACKEND_FILE_URL + settingInfo.website_logo}
                  alt={settingInfo.site_title}
                  className="brand-logo-img"
                />
              ) : (
                <img
                  src={logo}
                  alt={settingInfo.site_title}
                  className="brand-logo-img img-fluid"
                />
              )}
            </Link>

            <button
              type="button"
              className="btn navbar-toggler border-0"
              id="slide-toggle"
              onClick={toggleNav}
              aria-label="Toggle navigation"
            >
              <span className="navbar-dash" />
              <span className="navbar-dash" />
              <span className="navbar-dash" />
            </button>

            <div className="slide navbar-slide" id="slideNav">
              <ul className="navbar-nav ms-auto p-0" id="elastic_parent">
                <li className="nav-item">
                  <NavLink className="nav-link" to="/" end>
                    Home
                  </NavLink>
                </li>

                <li className="nav-item">
                  <NavLink className="nav-link" to="/about-us/">
                    About Us
                  </NavLink>
                </li>

                <li className="nav-item dropdown">
                  <NavLink
                    to="/services/"
                    className="nav-link dropdown-toggle d-none d-lg-flex"
                  >
                    Services
                  </NavLink>

                  <button
                    type="button"
                    className="nav-link dropdown-toggle d-lg-none d-flex bg-transparent border-0"
                    onClick={handleDropdownClick}
                    data-bs-toggle="dropdown"
                  >
                    Services
                  </button>

                  <ul className="dropdown-menu">
                    <li>
                      <NavLink className="dropdown-item d-lg-none" to="/services/" end>
                        All Services
                      </NavLink>
                    </li>
                    <li>
                      <NavLink className="dropdown-item" to="/services/strategy-and-decision-making/">
                        Strategy & Decision Making
                      </NavLink>
                    </li>
                    <li>
                      <NavLink className="dropdown-item" to="/services/operational-excellence/">
                        Operational Excellence
                      </NavLink>
                    </li>
                    <li>
                      <NavLink className="dropdown-item" to="/services/org-transformation-and-change-management/">
                        Org. Transformation & Change Management
                      </NavLink>
                    </li>
                    <li>
                      <NavLink className="dropdown-item" to="/services/digital-transformation/">
                        Digital Transformation
                      </NavLink>
                    </li>
                  </ul>
                </li>

                {/* NEWSLETTER */}
                <li className="nav-item">
                  <Link
                    className={`nav-link ${isNewsletterActive ? "active" : ""}`}
                    to="/resources/newsletter/"
                  >
                    Newsletters
                  </Link>
                </li>

                {/* RESOURCES */}
                <li className="nav-item">
                  <Link
                    className={`nav-link ${isResourcesActive ? "active" : ""}`}
                    to="/resources/"
                  >
                    Resources
                  </Link>
                </li>

                <li className="nav-item">
                  <NavLink className="nav-link" to="/careers/">
                    Careers
                  </NavLink>
                </li>

                <li className="nav-item">
                  <NavLink className="nav-link" to="/contact-us/">
                    Contact Us
                  </NavLink>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </div>
    </header>
  );
}
